import styled from 'styled-components';
import {
  DropDown,
  FlexColumn,
  InfoTooltip,
} from '@elementary/common-ui/components';
import { capitalize } from '@elementary/common-ui/utils/common';
import { QualityDimension } from 'shared/types';

const Link = styled.a`
  color: ${({ theme }) => theme.palette.common.blue4};
  text-decoration: underline;
`;

type Props = {
  onChange: (value?: QualityDimension) => void;
  value?: QualityDimension;
};

const QualityDimensionSelector = ({ onChange, value }: Props) => (
  <>
    <FlexColumn sx={{ gap: 1 }}>
      <DropDown
        sx={{ width: '200px' }}
        options={[
          'completeness',
          'uniqueness',
          'freshness',
          'validity',
          'accuracy',
          'consistency',
        ].map((v) => ({ label: capitalize(v), value: v }))}
        onChange={(v) => onChange((v as QualityDimension) || undefined)}
        value={value}
      />
    </FlexColumn>
    <InfoTooltip
      title={
        <p>
          The selected quality dimension will be used to feature this test in
          the{' '}
          <Link href="https://docs.elementary-data.com/features/collaboration-and-communication/data-health">
            data health score
          </Link>{' '}
          calculations
        </p>
      }
    />
  </>
);

export default QualityDimensionSelector;
